import styled from 'styled-components';

const InlineDialogChild = styled.div`
  height: 100%;
  position: absolute;
  visibility: hidden;
  width: 100%;
`;

InlineDialogChild.displayName = 'InlineDialogChild';

export default InlineDialogChild;
